var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExval(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 432.739,
    height: 119.54,
    viewBox: "0 0 432.739 119.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_312",
    "data-name": "Groupe 312",
    transform: "translate(-0.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2401",
    "data-name": "Trac\\xE9 2401",
    d: "M62.646,93.2H33.018l33.57-43.279L34.1,7.914H65.518L82.365,30.254,99.212,7.914h29.84L96.825,49.295,130.159,93.2H100.045L81.172,68.8Z",
    transform: "translate(69.694 24.756)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2402",
    "data-name": "Trac\\xE9 2402",
    d: "M142.989,117.956H108.338L62.1,0H93.642l32.737,86.722L157.089,0h28.883Z",
    transform: "translate(131.078)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2403",
    "data-name": "Trac\\xE9 2403",
    d: "M159.949,83.289q-2.982,4.95-10.157,9.125T130.2,96.6h-1.555q-15.17,0-22.516-7.92a24.591,24.591,0,0,1-5.46-8.834A31.645,31.645,0,0,1,98.778,68.7V67.6q0-11.731,6.278-17.754t20.727-7.771l29.391-3.646c2.7-.429,4.053-1.914,4.053-4.438a6.282,6.282,0,0,0-.771-3.3c-.52-.841-2.087-1.65-4.722-2.458a40.86,40.86,0,0,0-11.19-1.188h-.6a33.721,33.721,0,0,0-7.821.792,21.163,21.163,0,0,0-4.9,1.65,6.792,6.792,0,0,0-2.635,2.541,10.543,10.543,0,0,0-1.244,2.376,17.262,17.262,0,0,0-.3,2.129H100.332v-.313a50.564,50.564,0,0,1,.485-7.375,23.682,23.682,0,0,1,2.761-7.541,20.925,20.925,0,0,1,6.091-7.128,33.017,33.017,0,0,1,11.314-4.834,69.728,69.728,0,0,1,17.744-2h6.564a84.271,84.271,0,0,1,18.4,1.749,38.9,38.9,0,0,1,11.712,4.29,18.159,18.159,0,0,1,6.327,6.6,21.917,21.917,0,0,1,2.663,7.194,52.835,52.835,0,0,1,.485,7.755V67.6c0,2.854,1.1,4.273,3.344,4.273h3.456v23.1H170.106Q161.38,95.021,159.949,83.289Zm-.722-26.152V54.432l-25.437,5.23a19.011,19.011,0,0,0-7.534,2.789,5.073,5.073,0,0,0-1.633,2.164,7.1,7.1,0,0,0-.52,2.984v.214a10.709,10.709,0,0,0,.756,3.847,8.161,8.161,0,0,0,1.994,2.968q2.758,2.855,8.962,2.855,10.27,0,16.848-6.187T159.227,57.138Z",
    transform: "translate(208.497 22.935)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2404",
    "data-name": "Trac\\xE9 2404",
    d: "M157.327,0V117.956H130.7V0Z",
    transform: "translate(275.871)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2405",
    "data-name": "Trac\\xE9 2405",
    d: "M82.762,37.4,99.372,68.632l15.554-42.651L90.42,15.767Z",
    transform: "translate(174.693 49.324)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2406",
    "data-name": "Trac\\xE9 2406",
    d: "M93.825,0H.152V26.7H93.825Z",
    transform: "translate(0.322)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2407",
    "data-name": "Trac\\xE9 2407",
    d: "M93.825,22.11H.152v26.7H93.825Z",
    transform: "translate(0.322 69.166)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2408",
    "data-name": "Trac\\xE9 2408",
    d: "M93.825,11.055H.152v26.7H93.825Z",
    transform: "translate(0.322 34.583)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2409",
    "data-name": "Trac\\xE9 2409",
    d: "M19.544,26.7H39.661V0H19.544Z",
    transform: "translate(41.253 0)",
    fill: "#50518e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2410",
    "data-name": "Trac\\xE9 2410",
    d: "M13.082,26.7H33.2V0H13.082Z",
    transform: "translate(27.614 0)",
    fill: "#e94a73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2411",
    "data-name": "Trac\\xE9 2411",
    d: "M6.614,26.7H26.731V0H6.614Z",
    transform: "translate(13.961 0)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2412",
    "data-name": "Trac\\xE9 2412",
    d: "M.147,26.7H20.264V0H.147Z",
    transform: "translate(0.311 0)",
    fill: "#1d1d33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2413",
    "data-name": "Trac\\xE9 2413",
    d: "M20.269,11.055H.152v26.7H20.269Z",
    transform: "translate(0.322 34.583)",
    fill: "#50518e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2414",
    "data-name": "Trac\\xE9 2414",
    d: "M26.731,11.055H6.614v26.7H26.731Z",
    transform: "translate(13.961 34.583)",
    fill: "#4cbfde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2415",
    "data-name": "Trac\\xE9 2415",
    d: "M33.2,11.055H13.081v26.7H33.2Z",
    transform: "translate(27.612 34.583)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2416",
    "data-name": "Trac\\xE9 2416",
    d: "M39.666,11.055H19.549v26.7H39.666Z",
    transform: "translate(41.264 34.583)",
    fill: "#1d1d33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2417",
    "data-name": "Trac\\xE9 2417",
    d: "M19.544,48.8H39.661v-26.7H19.544Z",
    transform: "translate(41.253 69.153)",
    fill: "#f7ac25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2418",
    "data-name": "Trac\\xE9 2418",
    d: "M13.082,48.8H33.2v-26.7H13.082Z",
    transform: "translate(27.614 69.153)",
    fill: "#3e3f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2419",
    "data-name": "Trac\\xE9 2419",
    d: "M6.614,48.8H26.731v-26.7H6.614Z",
    transform: "translate(13.961 69.153)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2420",
    "data-name": "Trac\\xE9 2420",
    d: "M.147,48.8H20.264v-26.7H.147Z",
    transform: "translate(0.311 69.153)",
    fill: "#1d1d33"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExval);
export default __webpack_public_path__ + "static/media/exval.804514208ecd14529885051424ce5f3e.svg";
export { ForwardRef as ReactComponent };